"use client";
import { jsx } from "react/jsx-runtime";
import { useCriteo } from "../../../../utils/criteo/CriteoProvider.js";
import { Analytics } from "../../../Analytics/index.js";
import { ProductTileCarouselClient } from "../ProductTileCarousel/ProductTileCarouselClient.js";
import { AdSetContainerStyles } from "../styles.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { COMPONENT_NAME } from "./constants.js";
function CriteoCarousel({
  contentStackEntry = {},
  locale,
  titleProps,
  products,
  placement,
  analytics,
  ParentSKUs,
  maxSlides,
  maxSlidesBySize,
  productTileSx,
  carouselContainerSx,
  sx = {},
  isProductDetailsPage = false
}) {
  var _a, _b;
  const { bdWHNumber } = useCriteo();
  const { criteo_placement_name } = (contentStackEntry == null ? void 0 : contentStackEntry.third_party_curation) || {};
  const {
    product_card_display_style,
    show_reviews,
    show_action_button,
    inventory_aware_listings,
    product_tile_data_source
  } = (contentStackEntry == null ? void 0 : contentStackEntry.product_display_style) || {};
  if (!products || !placement) return null;
  const testId = `${COMPONENT_NAME}_${criteo_placement_name}`;
  const analyticsAdItem = {
    adItem: {
      style: "carousel",
      title: (_a = contentStackEntry == null ? void 0 : contentStackEntry.ad_set_heading_and_costco_url) == null ? void 0 : _a.title,
      type: "product"
    },
    title: contentStackEntry.title,
    trackType: "ad"
  };
  let finalAdSetContainertyles = {};
  if (!isProductDetailsPage) {
    finalAdSetContainertyles = AdSetContainerStyles;
  }
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      "data-testid": testId,
      sx: { ...finalAdSetContainertyles, ...sx },
      children: /* @__PURE__ */ jsx(Analytics, { analyticData: analyticsAdItem, children: /* @__PURE__ */ jsx(
        ProductTileCarouselClient,
        {
          bdWHNumber,
          analytics,
          containerSx: carouselContainerSx,
          criteoDataSourceAttr: true,
          dataPrivate: (_b = contentStackEntry == null ? void 0 : contentStackEntry.enable_url_tracking) == null ? void 0 : _b.disable_third_party_tracking,
          inventoryAware: inventory_aware_listings,
          isProductDetailsPage,
          itemNumbers: ParentSKUs,
          locale,
          maxSlides,
          maxSlidesBySize,
          pageType: void 0,
          productTileSx,
          showActionButton: show_action_button,
          showReviews: show_reviews,
          testId,
          titleProps,
          variant: product_card_display_style,
          product_tile_data_source,
          ...isProductDetailsPage && { peekAdjacent: "1rem" },
          ...isProductDetailsPage && { wrapAround: false },
          isCriteo: true
        }
      ) })
    }
  );
}
export {
  CriteoCarousel
};
